const styles = (theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
  },
  propertyAddress: {
    bottom: '1px',
    marginRight: '10px',
    position: 'relative',
  },
  propertyAddressContainer: {
    marginLeft: '15px',
  },
  logo: {
    width: '26px',
    height: '26px',
    marginRight: '13px',
    display: 'contents',
  },
  logoImage: {
    width: '25px',
    height: '25px',
    bottom: '2px',
    position: 'relative',
    fill: theme.palette.primary.main,
  },
});

export default styles;
